import { render, staticRenderFns } from "./poor.vue?vue&type=template&id=5a7a62ee"
import script from "./poor.vue?vue&type=script&lang=js"
export * from "./poor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports